module.exports = __webpack_public_path__ + "static/media/bvlgari-goldea-big.416ba647.png";